import styled from "styled-components";
import {GameDescriptionTextDefaultBox} from './game-description-text.default.box';

export const GameDescriptionSIBox = styled(GameDescriptionTextDefaultBox)`
  color: ${props => props.theme.colors.textDark};
`;
